import type { FC } from 'react'
import { useCallback } from 'react'
import { useState } from 'react'

import type { ButtonProps } from '@app/components/ui/button'
import { Button } from '@app/components/ui/button'
import { toaster } from '@app/components/ui/toaster'
import { useStore } from '@app/store'
import { StrategyReviewSend } from '@graphql/documents/strategy.graphql'
import type { Strategy } from '@graphql/queries'

type Props = ButtonProps & {
  strategy: Pick<Strategy, 'id'>
}

const SendStrategyReviewButton: FC<Props> = ({ strategy, ...rest }) => {
  const [loading, setLoading] = useState(false)
  const actionMutation = useStore.use.actionMutation()

  const onClick = useCallback(
    async (e) => {
      e.preventDefault()

      setLoading(true)
      try {
        const resp = await actionMutation(StrategyReviewSend, { strategyId: strategy.id })
        const errors = resp?.data?.strategyReviewSend?.errors

        if (errors?.length > 0) {
          toaster.create({
            title: 'Error sending review',
            description: errors[0].message,
            type: 'error'
          })
        } else {
          toaster.create({
            title: 'Review sent',
            type: 'success'
          })
        }
      } finally {
        setLoading(false)
      }
    },
    [setLoading, strategy.id, actionMutation]
  )

  return (
    <Button loading={loading} onClick={onClick} variant="subtle" {...rest}>
      Send to Slack now
    </Button>
  )
}

export default SendStrategyReviewButton
